'use client';

import i18next from 'i18next';
import { useMutation } from '@tanstack/react-query';

import { JWT_STORAGE_KEY, USER_ID_STORAGE_KEY } from 'src/utils/constants/constant';

import { restClient } from 'src/lib/api';
// const lang = i18next.language || 'ar';
export const getLocationPrediction = async (searchInput) => {
  const lang = localStorage.getItem('i18nextLng') || 'ar';

  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const userID = localStorage.getItem(USER_ID_STORAGE_KEY);

  const res = await restClient.get('getCityThroughAddress', {
    params: {
      token,
      userID,
      searchInput,
      language: lang,
      orderPlacedBy: 'ShahenWebSite',
    },
  });
  // const res = await axios.get('/api/location', {
  //   params: {
  //     address: searchInput, // your query param
  //   },
  // });
  return res?.data;
};

export const getLocationByCord = async (searchInput) => {
  const lang = localStorage.getItem('i18nextLng') || 'ar';

  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const userID = localStorage.getItem(USER_ID_STORAGE_KEY);

  const res = await restClient.get('getCityThroughLocation', {
    params: {
      token,
      userID,
      searchInput,
      language: lang,
      orderPlacedBy: 'ShahenWebSite',
    },
  });
  // const res = await axios.get('/api/location', {
  //   params: {
  //     latlng: searchInput, // your query param
  //   },
  // });
  return res?.data;
};

export const useGetLongURLFromShort = (url) =>
  useMutation({
    mutationFn: () =>
      restClient.get('googleUrl', { params: { url } }).then((res) => res?.data?.['expandedUrl']),
  });
